import { FC, ReactNode } from 'react'

import { Skeleton, SxProps, Theme, Typography } from '@mui/material'

type QueryStateBoundaryProps = {
  isLoading: boolean
  isError: boolean
  errorText: ReactNode
  skeletonHeight?: number
  skeletonSx?: SxProps<Theme>
  children: ReactNode
}

/** A skeleton while loading, the error text when loading failed, and the children otherwise. */
export const QueryStateBoundary: FC<QueryStateBoundaryProps> = ({ isLoading, isError, errorText, skeletonHeight = 320, skeletonSx, children }) => {
  if (isLoading) return <Skeleton variant="rectangular" height={skeletonHeight} sx={skeletonSx} />
  if (isError) return <Typography color="error.main">{errorText}</Typography>
  return <>{children}</>
}
